/// <amd-module name="PipelineChecks/Authorization/Client/RestClient/PipelinePermissions" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   distributedtask\web\extensions\vss-distributedtask-web\common\pipelinechecks-auth-client\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as PipelinePermissions from "PipelineChecks/Authorization/Client/Contracts/PipelinePermissions";

export interface IPipelinePermissionsRestClient extends IVssRestClient {
    /**
     * Given a ResourceType and ResourceId, returns authorized definitions for that resource.
     * 
     * @param project - Project ID or project name
     * @param resourceType - 
     * @param resourceId - 
     */
    getPipelinePermissionsForResource(project: string, resourceType: string, resourceId: string): Promise<PipelinePermissions.ResourcePipelinePermissions>;
    /**
     * Authorizes/Unauthorizes a list of definitions for a given resource.
     * 
     * @param resourceAuthorization - 
     * @param project - Project ID or project name
     * @param resourceType - 
     * @param resourceId - 
     */
    updatePipelinePermisionsForResource(resourceAuthorization: PipelinePermissions.ResourcePipelinePermissions, project: string, resourceType: string, resourceId: string): Promise<PipelinePermissions.ResourcePipelinePermissions>;
}

class PipelinePermissionsRestClient extends RestClientBase implements IPipelinePermissionsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Given a ResourceType and ResourceId, returns authorized definitions for that resource.
     * 
     * @param project - Project ID or project name
     * @param resourceType - 
     * @param resourceId - 
     */
    public async getPipelinePermissionsForResource(
        project: string,
        resourceType: string,
        resourceId: string
        ): Promise<PipelinePermissions.ResourcePipelinePermissions> {

        return this.beginRequest<PipelinePermissions.ResourcePipelinePermissions>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/pipelines/pipelinePermissions/{resourceType}/{resourceId}",
            routeValues: {
                project: project,
                resourceType: resourceType,
                resourceId: resourceId
            }
        });
    }

    /**
     * Authorizes/Unauthorizes a list of definitions for a given resource.
     * 
     * @param resourceAuthorization - 
     * @param project - Project ID or project name
     * @param resourceType - 
     * @param resourceId - 
     */
    public async updatePipelinePermisionsForResource(
        resourceAuthorization: PipelinePermissions.ResourcePipelinePermissions,
        project: string,
        resourceType: string,
        resourceId: string
        ): Promise<PipelinePermissions.ResourcePipelinePermissions> {

        return this.beginRequest<PipelinePermissions.ResourcePipelinePermissions>({
            apiVersion: "5.1-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/pipelines/pipelinePermissions/{resourceType}/{resourceId}",
            routeValues: {
                project: project,
                resourceType: resourceType,
                resourceId: resourceId
            },
            body: resourceAuthorization
        });
    }

}

export const PipelinePermissionsClientName = "dt.pipeline.authorization.client.IPipelinePermissionsRestClient";

export function getPipelinePermissionsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPipelinePermissionsRestClient {
    return pageContext.getRestClient<IPipelinePermissionsRestClient>(PipelinePermissionsClientName, options);
}

RestClients.add(PipelinePermissionsClientName, { 
    factory: PipelinePermissionsRestClient,
    options: {
        resourceAreaId: "a81a0441-de52-4000-aa15-ff0e07bfbbaa",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
